import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InternetBankingActions from '../../../actions/InternetBankingActions';

function withBatchPayments(WrappedComponent) {
  class WithBatchPayments extends Component {
    setBatch(props) {
      const isBatch = /\/movemoney\/batchpayments$/.test(props.location.path);
      InternetBankingActions.setBatchPayment(isBatch);
    }

    componentDidMount() {
      this.setBatch(this.props);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.location.path === this.props.location.path) return;
      this.setBatch(nextProps);
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  WithBatchPayments.propTypes = {
    location: PropTypes.shape({
      path: PropTypes.string.isRequired,
    }),
  };

  return WithBatchPayments;
}

export { withBatchPayments };
